import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

import type { DocumentRevision } from '../model/types';

const RECORD_APPROVAL_URL = '/matrices/awaiting-approval';
const DOCUMENT_APPROVAL_URL = '/document-revisions/awaiting-approval';
const RECORD_VERIFICATION_URL = '/matrices/awaiting-verification';
const DOCUMENT_VERIFICATION_URL = '/document-revisions/awaiting-verification';

/**
 * Carrega o item de uma etapa de homologação pela fonte da natureza dele.
 *
 * A natureza vem do segmento da rota de detalhe, e não de uma tentativa: o mesmo id existe nas duas
 * tabelas, então pedir uma fonte e cair para a outra abriria o item errado sempre que os dois
 * números coincidissem.
 */
async function fetchItem(
  baseUrl: string,
  id: string | number
): Promise<ApiResponse<DocumentRevision>> {
  const response = await api.get(`${baseUrl}/${id}`);
  return response.data as ApiResponse<DocumentRevision>;
}

export function fetchApprovalItem(
  id: string | number,
  isRecord: boolean
): Promise<ApiResponse<DocumentRevision>> {
  return fetchItem(isRecord ? RECORD_APPROVAL_URL : DOCUMENT_APPROVAL_URL, id);
}

export function fetchVerificationItem(
  id: string | number,
  isRecord: boolean
): Promise<ApiResponse<DocumentRevision>> {
  return fetchItem(isRecord ? RECORD_VERIFICATION_URL : DOCUMENT_VERIFICATION_URL, id);
}
